module.exports = __webpack_public_path__ + "img/Slot.4a7a5f30.svg";